/** API 호출 , 같은 origin 의 /api. 쿠키 세션이라 credentials 를 늘 보낸다 */
export class ApiError extends Error {
  status: number;
  issues?: unknown;
  constructor(status: number, message: string, issues?: unknown) {
    super(message);
    this.status = status;
    this.issues = issues;
  }
}

const BASE = import.meta.env.VITE_API_BASE ?? "/api";

export async function api<T>(path: string, init: RequestInit & { json?: unknown } = {}): Promise<T> {
  const { json, headers, ...rest } = init;
  const res = await fetch(`${BASE}${path}`, {
    credentials: "include",
    headers: { ...(json !== undefined ? { "content-type": "application/json" } : {}), ...(headers ?? {}) },
    body: json !== undefined ? JSON.stringify(json) : rest.body,
    ...rest,
  });
  const text = await res.text();
  let body: unknown = null;
  try {
    body = text ? JSON.parse(text) : null;
  } catch {
    body = text;
  }
  if (!res.ok) {
    const b = body as { error?: string; issues?: unknown } | null;
    throw new ApiError(res.status, b?.error ?? `요청 실패 (${res.status})`, b?.issues);
  }
  return body as T;
}

export const apiUrl = (path: string) => `${BASE}${path}`;
